import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface OverlayFooterProps extends HTMLAttributes<HTMLDivElement> {
  primary?: ReactNode
  secondary?: ReactNode
}

export function OverlayFooter({
  primary,
  secondary,
  className,
  children,
  ...props
}: OverlayFooterProps) {
  if (children) {
    return (
      <footer
        className={cn(
          'flex items-center justify-end gap-2 px-5 py-3 border-t border-border-default bg-surface-elevated',
          className,
        )}
        {...props}
      >
        {children}
      </footer>
    )
  }

  return (
    <footer
      className={cn(
        'flex items-center justify-end gap-2 px-5 py-3 border-t border-border-default bg-surface-elevated',
        className,
      )}
      {...props}
    >
      {secondary}
      {primary}
    </footer>
  )
}
